import UpdateSlider from "../../components/UpdateSlider";
function UpdateSliderPage() {
  return <UpdateSlider />;
}

export default UpdateSliderPage;
